import { useModal } from "contexts/ModalContext";
import { trackClickEvent, buildTrackingBasedId } from "utils/trackingUtils";
import type { As, ButtonProps } from "@chakra-ui/react";
import type { ReactStoryblokComponent } from "types/storyblok";
import { useStoryblokLink } from "hooks";
import { ChakraButton as Button } from "@airhelp/react-ui-components";
import type { ButtonStoryblokAdapterProps } from "./Button.d";
import { modals, sizes, variants } from "./Button.config";

const ButtonStoryblokAdapter = ({
  blok: { size, text, variant, link, modal, modalSize = "md", gtmSection, gtmElement },
}: ReactStoryblokComponent<ButtonStoryblokAdapterProps>) => {
  const { openModal } = useModal();
  const href = useStoryblokLink(link);
  const trackingEvents = () => trackClickEvent(gtmSection, gtmElement);

  const buttonModalProps = {
    size: sizes[size],
    onClick: () => {
      openModal(modals[modal], modalSize);
      trackingEvents();
    },
    variant: variants[variant],
    minW: "fit-content",
    whiteSpace: "nowrap",
  } as ButtonProps;

  const buttonProps = {
    onClick: trackingEvents,
    variant: variants[variant],
    size: sizes[size],
    as: "a" as As<unknown>,
    href,
  };

  const props = modal ? buttonModalProps : buttonProps;

  return (
    <Button id={buildTrackingBasedId(gtmSection, gtmElement)} {...props}>
      {text}
    </Button>
  );
};

export default ButtonStoryblokAdapter;
